// extracted by mini-css-extract-plugin
module.exports = {"tab":"FeedbackBanner_tab__1_PYa"};